module.exports = __webpack_public_path__ + "media/flags/gu-2c9200ac.svg";